import { render } from "./SectionSpacer.vue?vue&type=template&id=32955f45&scoped=true"
import script from "./SectionSpacer.vue?vue&type=script&lang=js"
export * from "./SectionSpacer.vue?vue&type=script&lang=js"

import "./SectionSpacer.vue?vue&type=style&index=0&id=32955f45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32955f45"]])

export default __exports__